import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { resolveCategoryUrl } from '../../../utilities/selectors';
import { DsiSvgIcon, IconType } from '../General/SvgIcon';
import { FlexRow } from '../../..';

export interface Props {
  id: number;
  name: string;
  url: string;
  level: number;
  numOfProducts?: number;
  onClick: any;
  active?: boolean;
  isOpen: boolean;
  hasMore?: boolean;
  onClickPlus?: (e) => any;
  icon?: IconType;
}

function NavigationDropdownItem({
  id,
  name,
  url,
  level,
  onClick,
  isOpen,
  hasMore = false,
  onClickPlus,
  icon,
}: Props) {
  return level === 0 ? (
    <Wrapper
      onClick={onClick}
      to={resolveCategoryUrl(id, url,'CATEGORYTEXT/URL')}
      // tslint:disable-next-line:jsx-no-lambda
    >
      {icon && <StyledDsiSvgIcon icon={icon} />}
      {hasMore && (
        <Plus onClick={onClickPlus}>
          {' '}
          {isOpen ? (
            <MinusIcon icon={IconType.minus} fill={'#414141'} />
          ) : (
            <PlusIcon icon={IconType.plus} fill={'#414141'} />
          )}
        </Plus>
      )}
      <NameArrow>
        <Name className="categoryName">{name}</Name>
        {hasMore && (
          <ArrowIcon icon={IconType.rightArrow} fill={'#414141'} width={50} />
        )}
      </NameArrow>
    </Wrapper>
  ) : level === 1 ? (
    <SecondLvlItemWrapper
      onClick={onClick}
      to={resolveCategoryUrl(id, url,'CATEGORYTEXT/URL')}
      // tslint:disable-next-line:jsx-no-lambda
    >
      {hasMore ? (
        <FlexRow>
          <Plus onClick={onClickPlus}>
            {' '}
            {isOpen ? (
              <MinusIcon icon={IconType.minus} fill={'#414141'} />
            ) : (
              <PlusIcon icon={IconType.plus} fill={'#414141'} />
            )}
          </Plus>
          <SecondName className="categoryName">{name}</SecondName>
        </FlexRow>
      ) : (
        <NameArrowWrapper>
          <Plus>
            <ArrowIcon icon={IconType.rightArrow} fill={'#CCCCCC'} width={50} />
          </Plus>
          <SecondName className="categoryName">{name}</SecondName>
        </NameArrowWrapper>
      )}
    </SecondLvlItemWrapper>
  ) : (
    <ThirdLvlItemWrapper
      onClick={onClick}
      to={resolveCategoryUrl(id, url,'CATEGORYTEXT/URL')}
      // tslint:disable-next-line:jsx-no-lambda
    >
      <NameArrowWrapper>
        <Plus>
          <ArrowIcon icon={IconType.rightArrow} fill={'#CCCCCC'} width={50} />
        </Plus>
        <SecondName className="categoryName">{name}</SecondName>
      </NameArrowWrapper>
    </ThirdLvlItemWrapper>
  );
}

const Wrapper = styled(Link)`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  padding: ${rem(8)} 0 ${rem(8)} ${rem(18)};
  margin-bottom: ${rem(8)};

  line-height: ${rem(22)};

  &.activeItem {
    background-color: ${(props: { firstLevel: boolean; theme: any }) =>
      props.firstLevel ? '' : props.theme.colors.hover};
  }

  &.activeItem > p.categoryName {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    background-color: ${(props: { firstLevel: boolean; theme: any }) =>
      props.firstLevel ? '' : props.theme.colors.hover};
  }

  &:hover > p.categoryName {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const SecondLvlItemWrapper = styled(Wrapper)`
  padding: ${rem(8)} 0 ${rem(8)} ${rem(30)};
`;

const ThirdLvlItemWrapper = styled(SecondLvlItemWrapper)`
  padding: ${rem(8)} 0 ${rem(8)} ${rem(40)};
`;

const Name = styled(TextP)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(16)};
  max-width: ${rem(192)};
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

const SecondName = styled(Name)`
  font-weight: 300;
`;

const NameArrow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const PlusIcon = styled(DsiSvgIcon)`
  position: relative;
  top: 6px;
  left: 6px;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
    top: 7px;
    left: 7px;
  }
`;

const MinusIcon = styled(PlusIcon)`
  top: 8px;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
    top: 9px;
  }
`;

const Plus = styled.div`
  cursor: pointer;
`;

const NameArrowWrapper = styled(FlexRow)`
  position: relative;
  left: ${rem(-15)};
`;

const ArrowIcon = styled(DsiSvgIcon)`
  position: relative;
  top: 6px;
  left: 6px;
  cursor: pointer;
  position: relative;
  top: -2px;
`;

const StyledDsiSvgIcon = styled(DsiSvgIcon)`
  margin-left: ${rem(5)};
  margin-right: ${rem(12)};
  flex-shrink: 0;
`;

export { NavigationDropdownItem as DsiNavigationDropdownItem };
